import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroller';
import { fromJS } from 'immutable';
import sortBy from 'lodash/sortBy';
import findIndex from 'lodash/findIndex';
import makeTrashable from 'trashable';
import LoadingIndicator from '../LoadingIndicator/index';
import { wallPostShape } from '../../utils/shapes';
import CommentList from '../CommentList';
import FadeElement from '../FadeElement';
import Post from './Post';
import './FeedList.css';

class FeedList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      commentInputShown: null,
      postsToRemove: []
    };

    this.toggleComments = this.toggleComments.bind(this);
    this.beginDeletePost = this.beginDeletePost.bind(this);
    this.deletePost = this.deletePost.bind(this);

    this.loadingMorePosts = null;
  }

  componentWillUnmount() {
    if (this.loadingMorePosts) {
      if (this.loadingMorePosts.trash) {
        this.loadingMorePosts.trash();
      }
      this.loadingMorePosts = null;
    }
  }

  getWrapperClassName(post) {
    const classes = ['feed-list-item'];
    if (post.isPinned === true) {
      classes.push('pinned');
    }
    if (
      post.comments &&
      post.comments.comments &&
      post.comments.comments.length > 0
    ) {
      classes.push('with-comments');
    }

    return classes.join(' ');
  }

  toggleComments(id) {
    if (this.state.commentInputShown === id) {
      this.setState({
        commentInputShown: null
      });
    } else {
      this.setState({
        commentInputShown: id
      });
    }
  }

  isNewPost(post) {
    return (
      findIndex(this.props.postsToAnimate, item => {
        return item.id === post.id;
      }) >= 0
    );
  }

  isPostRemoving(post) {
    return (
      findIndex(this.state.postsToRemove, item => {
        return item === post.id;
      }) >= 0
    );
  }

  loadMorePosts() {
    if (
      !this.props.loading &&
      !this.loadingMorePosts &&
      this.props.hasAnyMore
    ) {
      this.loadingMorePosts = makeTrashable(this.props.loadMorePosts()).finally(
        () => (this.loadingMorePosts = null)
      );
    }
  }

  loadMoreComments(post, callback) {
    this.props.loadMoreComments(post, callback);
  }

  beginDeletePost(post) {
    this.setState({
      postsToRemove: fromJS(this.state.postsToRemove)
        .push(post.id)
        .toJS()
    });
  }

  deletePost(post) {
    this.props.onDeletePost(post);
  }

  render() {
    const { posts, loading } = this.props;

    if (posts.length === 0) {
      if (loading) {
        return <LoadingIndicator expand />;
      } else {
        return (
          <div className="text-center feed-alert">
            No posts available at this time.
          </div>
        );
      }
    }

    let sortedPosts = sortBy(posts, post => (post.isPinned ? 0 : 1));

    return (
      <InfiniteScroll
        pageStart={0}
        loadMore={this.loadMorePosts.bind(this)}
        hasMore={this.props.hasAnyMore}
        loader={
          this.props.hasAnyMore ? (
            <div className="loader">Loading...</div>
          ) : null
        }
        useWindow={false}
      >
        <ul className="feed-list">
          {sortedPosts.map(post => {
            let postElement = (
              <Post
                post={post}
                user={this.props.user}
                onDeletePost={this.beginDeletePost}
                toggleComments={this.toggleComments}
                onPinWallPost={this.props.onPinWallPost}
                onUnpinWallPost={this.props.onUnpinWallPost}
                onLikePost={this.props.onLikePost}
                onUnlikePost={this.props.onUnlikePost}
              />
            );
            return (
              <li className={this.getWrapperClassName(post)} key={post.id}>
                <FadeElement
                  onPostAnimationComplete={() => {
                    this.props.onPostAnimationComplete(post);
                  }}
                  onRemoveComplete={() => {
                    this.deletePost(post);
                  }}
                  in={!this.isNewPost(post)}
                  removing={this.isPostRemoving(post)}
                >
                  {postElement}
                </FadeElement>
                <CommentList
                  addComment={(postId, message) => {
                    if (this.props.addComment(postId, message)) {
                      this.toggleComments(postId);
                      return true;
                    }
                    return false;
                  }}
                  commentInputShown={this.state.commentInputShown}
                  post={post}
                  onDeleteComment={this.props.onDeleteComment}
                  user={this.props.user}
                  loadMoreComments={this.loadMoreComments.bind(this)}
                  commentsToAnimate={this.props.commentsToAnimate}
                  onCommentAnimationComplete={
                    this.props.onCommentAnimationComplete
                  }
                  onLikeComment={this.props.onLikeComment}
                  onUnlikeComment={this.props.onUnlikeComment}
                />
              </li>
            );
          })}
        </ul>
      </InfiniteScroll>
    );
  }
}

FeedList.propTypes = {
  addComment: PropTypes.func,
  posts: PropTypes.arrayOf(wallPostShape),
  commentInputShown: PropTypes.number,
  onDeleteComment: PropTypes.func,
  onDeletePost: PropTypes.func,
  hasAnyNext: PropTypes.bool,
  loadMorePosts: PropTypes.func,
  loadMoreComments: PropTypes.func,
  loading: PropTypes.bool,
  error: PropTypes.instanceOf(Error),
  postsToAnimate: PropTypes.array,
  commentsToAnimate: PropTypes.array,
  onPostAnimationComplete: PropTypes.func,
  onCommentAnimationComplete: PropTypes.func,
  onPinWallPost: PropTypes.func,
  onUnpinWallPost: PropTypes.func,
  onLikePost: PropTypes.func,
  onUnlikePost: PropTypes.func,
  onLikeComment: PropTypes.func,
  onUnlikeComment: PropTypes.func
};

export default FeedList;



// WEBPACK FOOTER //
// ./src/components/FeedList/index.js